import { hydrate } from '@solidjs/web';
import { DefaultErrorBoundary } from "virtual:solid-ssr-error-boundary.tsx";
import Document from "/home/runner/work/cf-effect-experiment/cf-effect-experiment/apps/website/src/Document.tsx";
import App from "/home/runner/work/cf-effect-experiment/cf-effect-experiment/apps/website/src/App.tsx";

hydrate(() => (
  <DefaultErrorBoundary>
    <Document>
      <DefaultErrorBoundary>
        <App />
      </DefaultErrorBoundary>
    </Document>
  </DefaultErrorBoundary>
), document);